export type NumberFormatOptions = {
  minimumFractionDigits?: number;
};

export const formatNumberToThousandths = (
  v: number,
  options?: NumberFormatOptions
) => {
  return new Intl.NumberFormat('en-us', options).format(v);
};
